var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMicrophone(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 23,
    viewBox: "0 0 19 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.1394 10.3574C13.1394 11.3914 12.7286 12.3831 11.9974 13.1143C11.2662 13.8455 10.2745 14.2563 9.24045 14.2563C8.2064 14.2563 7.21469 13.8455 6.48351 13.1143C5.75233 12.3831 5.34155 11.3914 5.34155 10.3574V4.8989C5.34155 3.86485 5.75233 2.87314 6.48351 2.14196C7.21469 1.41078 8.2064 1 9.24045 1C10.2745 1 11.2662 1.41078 11.9974 2.14196C12.7286 2.87314 13.1394 3.86485 13.1394 4.8989V10.3574Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0381 11.1372C17.0401 12.0594 16.86 12.9729 16.5082 13.8253C16.1562 14.6777 15.6393 15.4522 14.9871 16.1042C14.3351 16.7563 13.5606 17.2733 12.7082 17.6251C11.8558 17.9771 10.9423 18.1573 10.0201 18.1552H8.46054C7.53834 18.1573 6.62483 17.9771 5.77244 17.6251C4.92004 17.2733 4.14557 16.7563 3.49347 16.1042C2.84137 15.4522 2.32452 14.6777 1.97255 13.8253C1.62059 12.9729 1.44046 12.0594 1.44252 11.1372",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.24023 18.1553V21.2744",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMicrophone);
export default __webpack_public_path__ + "static/media/microphone.e0d83ce6dddf84aa890ac0eff369e701.svg";
export { ForwardRef as ReactComponent };